module.exports = __webpack_public_path__ + "images/help/icon-twr50@2x-26aa0931662333939d8a56d253567f60.png";